module.exports = __webpack_public_path__ + "static/media/cover-login-access-4.03133da1.jpg";